import type { ReactNode } from "react";
import { connect } from "react-redux";

import actions from "@/actions";

import Button from "../base/Button";

const renderIcon = (color: string): ReactNode => (
    <svg width="33px" height="34px" viewBox="0 0 23 20" version="1.1">
        <title>show-eye</title>
        <desc>Created with Sketch.</desc>
        <g
            id="Symbols---Zep"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="LS-Menu" fill={color} fillRule="nonzero">
                <g className="nc-icon-wrapper" transform="translate(0.5, 0.5)">
                    <path
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                        strokeLinecap="square"
                        strokeMiterlimit="10"
                        d="M2,12c0,0,4-6,10-6 c6,0,10,6,10,6s-4,6-10,6C6,18,2,12,2,12z"
                        strokeLinejoin="miter"
                    />
                    <circle
                        data-color="color-2"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                        strokeLinecap="square"
                        strokeMiterlimit="10"
                        cx="12"
                        cy="10"
                        r="4"
                        strokeLinejoin="miter"
                    />
                </g>
            </g>
        </g>
    </svg>
);

const MenuButton = (props: React.ComponentProps<typeof Button>) => (
    <Button {...props} renderIcon={renderIcon} />
);

const mapStateToProps = ({ topBar }: { topBar: any }) => ({
    hidden: !topBar.options.autoHideTopBar,
});

const mapDispatchToProps = {
    onClick: () => actions.topBar.setVisibility(true),
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuButton);
